module.exports = __webpack_public_path__ + "static/media/4.9146e7a2.jpg";